export const titleHr = '/images/bg_off.png';
export const contactMap = '/images/contactMap.png';
export const lectureFearAndAgression = '/images/foredragAngstAggression.jpg';
export const lectureDogLanguage = '/images/foredragHundensSprog.jpg';
export const lectureCalmDownFido = '/images/foredragSlapAfFido.jpg';
export const FrontNoTwo = '/images/Forside2.JPG';
export const FrontNoOne = '/images/Front1.jpg';
export const CoolOne = '/images/HoldCool1.jpg';
export const CoolTwo = '/images/HoldCool2.jpg';
export const CoolThree = '/images/HoldCool3.png';
export const CoolFour = '/images/HoldCool4.jpg';
export const CoolFive = '/images/HoldCool5.jpg';
export const CoolSix = '/images/HoldCool6.jpg';
export const CoolAgainOne = '/images/HoldFortsatCool1.jpg';
export const CoolAgainTwo = '/images/HoldFortsatCool2.jpg';
export const CoolAgainThree = '/images/HoldFortsatCool3.jpg';
export const CoolAgainFour = '/images/HoldFortsatCool4.jpg';
export const CoolAgainFive = '/images/HoldFortsatCool5.jpg';
export const CoolAgainSix = '/images/HoldFortsatCool6.jpg';
export const CoolAgainSeven = '/images/HoldFortsatCool7.jpg';
export const CoolAgainEight = '/images/HoldFortsatCool8.jpg';
export const CoolAgainNine = '/images/HoldFortsatCool9.jpg';
export const PuppyOne = '/images/HoldHvalp1.jpg';
export const PuppyTwo = '/images/HoldHvalp2.jpg';
export const PuppyThree = '/images/HoldHvalp3.jpg';
export const PuppyFour = '/images/HoldHvalp4.jpg';
export const PuppyFive = '/images/HoldHvalp5.jpg';
export const PuppySix = '/images/HoldHvalp6.jpg';
export const PuppySeven = '/images/HoldHvalp7.jpg';
export const PuppyEight = '/images/HoldHvalp8.jpg';
export const PuppyNine = '/images/HoldHvalp9.jpg';
export const PuppyContinuedOne = '/images/HoldHvalpFortsat1.jpg';
export const PuppyContinuedTwo = '/images/HoldHvalpFortsat2.jpg';
export const PuppyContinuedThree = '/images/HoldHvalpFortsat3.jpg';
export const PuppyContinuedFour = '/images/HoldHvalpFortsat4.jpg';
export const PuppyContinuedFive = '/images/HoldHvalpFortsat5.jpg';
export const PuppyContinuedSix = '/images/HoldHvalpFortsat6.jpg';
export const RecallOne = '/images/HoldIndkald1.jpg';
export const RecallTwo = '/images/HoldIndkald2.JPG';
export const RecallThree = '/images/HoldIndkald3.PNG';
export const RecallFour = '/images/HoldIndkald4.JPG';
export const RecallFive = '/images/HoldIndkald5.PNG';
export const RecallSix = '/images/HoldIndkald6.PNG';
export const PlayOne = '/images/HoldLeg1.jpg';
export const PlayTwo = '/images/HoldLeg2.jpg';
export const PlayThree = '/images/HoldLeg3.jpg';
export const PlayFour = '/images/HoldLeg4.jpg';
export const PlayFive = '/images/HoldLeg5.jpg';
export const PlaySeven = '/images/HoldLeg7.jpg';
export const PlayEight = '/images/HoldLeg8.jpg';
export const PlayNine = '/images/HoldLeg9.jpg';
export const NailClipOne = '/images/HoldNegleklip1.jpg';
export const NailClipTwo = '/images/HoldNegleklip2.jpg';
export const NailClipThree = '/images/HoldNegleklip3.jpg';
export const NailClipFour = '/images/HoldNegleklip4.jpg';
export const NailClipFive = '/images/HoldNegleklip5.png';
export const NailClipSix = '/images/HoldNegleklip6.jpg';
export const NailClipSeven = '/images/HoldNegleklip7.png';
export const NailClipEight = '/images/HoldNegleklip8.jpg';
export const NailClipNine = '/images/HoldNegleklip9.jpg';
export const TricksOne = '/images/HoldTricks1.jpg';
export const TricksTwo = '/images/HoldTricks2.jpg';
export const TricksThree = '/images/HoldTricks3.jpg';
export const TricksFour = '/images/HoldTricks4.jpg';
export const TricksFive = '/images/HoldTricks5.jpg';
export const TricksSix = '/images/HoldTricks6.jpg';
export const dogOne = '/images/hund1.png';
export const dogTwo = '/images/hund2.png';
export const dogThree = '/images/hund3.jpg';
export const ClubCover = '/images/Hundesprogsklubben.png';
export const Sunday1 = '/images/hygge1.jpg';
export const Sunday2 = '/images/hygge2.jpg';
export const Sunday3 = '/images/hygge3.jpg';
export const catOne = '/images/kat1.jpg';
export const catTwo = '/images/kat2.jpg';
export const catThree = '/images/kat3.jpg';
export const catFour = '/images/Kat4.png';
export const LogoUpdate = '/images/LogoUpdate.png';
export const LogoUpdateBlack = '/images/LogoUpdateBlack.png';
export const methodOne = '/images/metode1.png';
export const methodTwo = '/images/metode2.jpg';
export const sabrinaNew = '/images/migNY.jpg';
export const NWGary = '/images/NoseWork.jpg';
export const OnlineCatsOne = '/images/OnlineCats1.png';
export const OnlineCatsTwo = '/images/OnlineCats2.png';
export const OnlineCatsThree = '/images/OnlineCats3.png';
export const OnlineConfident = '/images/onlineConfident.JPG';
export const OnlineCoverCatScratch = '/images/OnlineCoverCatScratch.png';
export const OnlineCoverCool = '/images/OnlineCoverCool.png';
export const OnlineCoverCourses = '/images/OnlineCoverCourses.png';
export const OnlineCoverDogPlay = '/images/OnlineCoverDogPlay.png';
export const OnlineCoverCourse = '/images/OnlineCoverHold.png';
export const OnlineCoverPuppyFive = '/images/OnlineCoverHvalp5.png';
export const OnlineCoverPuppyCourse = '/images/OnlineCoverHvalpehold.png';
export const OnlineCoverPuppy = '/images/OnlineCoverPuppy.png';
export const OnlineCoverSpot = '/images/OnlineCoverSpot.png';
export const OnlineGuests = '/images/onlineGuests.PNG';
export const OnlineGarden = '/images/onlineHaven.png';
export const OnlineBookpuppy = '/images/onlineHvalpebog.png';
export const OnlineRelax = '/images/onlineIntet.jpg';
export const OnlineLook = '/images/onlineKig.png';
export const OnlinePlayFull = '/images/onlineKontrolleg.PNG';
export const OnlinePlay = '/images/onlineLeg.PNG';
export const OnlineSound = '/images/onlineLyd.png';
export const OnlineNail = '/images/onlineNail.PNG';
export const OnlinePulling = '/images/onlinePulling.png';
export const OnlineRecall = '/images/onlineRecall.PNG';
export const OnlineStress = '/images/onlineStress.JPG';
export const OnlineSummer = '/images/OnlineSummer.jpg';
export const OnlineVisit = '/images/onlineVisit.png';
export const OnlinePupOne = '/images/OnlinePup1.png';
export const OnlinePupTwo = '/images/OnlinePup2.png';
export const OnlinePupThree = '/images/OnlinePup3.png';
export const OnlinePupFour = '/images/OnlinePup4.png';
export const OnlinePupFive = '/images/OnlinePup5.png';
export const OnlinePuppyBook = '/images/OnlinePuppy1.png';
export const petbc = '/images/petbc.jpg';
export const sabrinaAndBarney = '/images/SabrinaAndBarney.jpg';
export const ConsultAggOne = '/images/SalgssideAgg1.jpg';
export const ConsultAggTwo = '/images/SalgssideAgg2.jpg';
export const ConsultPupOne = '/images/SalgssideHvalp1.jpg';
export const ConsultPupTwo = '/images/SalgssideHvalp2.jpg';
export const ConsultPupThree = '/images/SalgssideHvalp3.jpg';
export const SnackshopCover = '/images/Snackshop.png';
export const TestiOnlineWalkOne = '/images/TestiOnlineWalk1.png';
export const TestiOnlineWalkTwo = '/images/TestiOnlineWalk2.jpg';
export const TestiOnlineWalkThree = '/images/TestiOnlineWalk3.jpg';
export const TestiCoolOne = '/images/TestiCool1.jpg';
export const TestiCoolTwo = '/images/TestiCool2.JPG';
export const TestiCoolThree = '/images/TestiCool3.jpg';
export const TestiCoolFour = '/images/TestiCool4.png';
export const TestiCoolFive = '/images/TestiCool5.JPG';
export const TestiCoolSix = '/images/TestiCool6.jpg';
export const TestiCoolSeven = '/images/TestiCool7.jpg';
export const TestiCoolEight = '/images/TestiCool8.jpg';
export const TestiCoolNine = '/images/TestiCool9.jpg';
export const TestiCoolTen = '/images/TestiCool10.JPG';
export const TestiCoolEleven = '/images/TestiCool11.jpg';
export const TestiPupOne = '/images/TestiPup1.jpg';
export const TestiPupTwo = '/images/TestiPup2.jpg';
export const TestiPupThree = '/images/TestiPup3.jpg';
export const TestiPupFour = '/images/TestiPup4.jpg';
export const TestiPupFive = '/images/TestiPup5.jpg';
export const TestiPupSix = '/images/TestiPup6.jpg';
export const TestiPupSeven = '/images/TestiPup7.jpg';
export const TestiPupEight = '/images/TestiPup8.jpg';
export const TestiPupNine = '/images/TestiPup9.jpg';
export const TestiPupTen = '/images/TestiPup10.jpg';
export const TestiPupEleven = '/images/TestiPup11.jpg';
export const TestiPupTwelve = '/images/TestiPup12.jpg';
export const TestiPupThirteen = '/images/TestiPup13.jpg';
export const TestiReactiveOne = '/images/TestiReactive1.jpg';
export const TestiReactiveTwo = '/images/TestiReactive2.jpg';
export const TestiReactiveThree = '/images/TestiReactive3.png';
export const TestiRecallOne = '/images/TestiRecall1.jpg';
